
import { useNavigate } from 'react-router';
import { useEffect } from 'react';

import { AuthTemplate } from '@/pages/unauthenticated/auth/components';
import { useGetAppContext } from '@/services/context/queries';

import { ThankYouSection } from './components/thank-you-section';

export function ThankYou() {
  const navigate = useNavigate();
  const { data: appContext, isError, isLoading } = useGetAppContext();

  useEffect(() => {
    if (isLoading) return;
    if (isError) {
      navigate('/register', { replace: true });
      return;
    }
    if (appContext?.user.emailVerified) {
      navigate('/dashboard', { replace: true });
    }
  }, [appContext, isError, isLoading, navigate]);

  if (!appContext) return null;

  const email = appContext.user.email;

  return (
    <AuthTemplate
      heading="Thank you for joining FlagSync!"
      subheading={<ThankYouSubheading email={email} />}
    >
      <ThankYouSection email={email} />
    </AuthTemplate>
  );
}

function ThankYouSubheading({ email }: { email: string }) {
  return (
    <div className="flex flex-col space-y-2">
      <span>
        Please check your inbox at{' '}
        <span className="font-semibold">{email}</span> for a link to verify your
        account.
      </span>
      <span>
        If you don’t see the email, be sure to check your spam or junk folder.
      </span>
    </div>
  );
}
